import { baseUrl, baseUrlServices } from "../shared/baseUrl"

export const requestPost = async (serviceName, formData) => {
  
    try {

        const headers = new Headers();
        headers.append('Authorization', `Bearer ${JSON.parse(localStorage.getItem('user_store_ecommerce'))}`);
        console.log(JSON.parse(localStorage.getItem('user_store_ecommerce')))

        if (!serviceName || !formData) {
            throw new Error("Service name or form data is missing");
        }

        const bodyRequest = {
            method: "POST",
            body: formData,
            headers
        }

        const responsePost = await fetch(baseUrl.concat(serviceName), bodyRequest);
        const response = responsePost.text();
        if (response !== '0') {
            return response;
        }
        
        return 'Error';
        
    } catch (error) {
        console.log(error);
    }

}
